(function ($) { 
  Drupal.behaviors.mppFilterSetV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var that = this;

      that.setup(context);
    },

    setup: function (context) {
      this.attached = true;

      var containerSelector = '.js-mpp-container';
      var gridSelector = '.js-mpp-grid-filterable';
      var itemSelector = '.js-mpp-grid-item-product';
      var $template = $('.js-mpp-filter-set__container', context);
      var $triggerBtn = $('.js-mpp-filter-cta', context);
      var $filterTitleBtn = $('.js-mpp-filter-title', context);
      var $closeBtn = $('.js-mpp-filter-cta--close', context);
      var $mixItUpEl = $(gridSelector, context);
      var $mppContainer = $(containerSelector, context);
      var $mppNode = $('.node-elc-mpp', context);
      var $html = $('html', context);

      $template.each(function () {
        var $thisTemplate = $(this);
        var $filtersParent = $thisTemplate.closest('.js-mpp-filter-set--v1');
        var $filterBtn = $('.js-mpp-filter-set-button', $thisTemplate);
        var $submitBtn = $('.js-mpp-filter-set-submit', $thisTemplate);
        var $resetBtn = $('.js-mpp-filter-set-reset', $thisTemplate);
        var $activeFiltersCount = $('.js-mpp-filter--active-filters-count', $mppContainer);

        // Add item count wrapper to submit
        $submitBtn.html(
          $submitBtn
            .html()
            .replace('PROD_COUNT', '<span class="js-breadcrumb__level--count-number"></span>')
        );

        var $triggerSets = $('.js-mpp-filter-set-section', $thisTemplate);
        var $filterSets = $('.js-mpp-filter-set__filters', $thisTemplate);
        var $collapsedFilter = $('.js-mpp-filter-set__title', $thisTemplate);
        var $productGrid = $(gridSelector, $mppContainer);
        var $products = $(itemSelector, $productGrid);
        var $itemCountContainer = $('.js-breadcrumb__level--count-number', $mppNode);
        var $controlsContainer = $('.js-mpp-container__controls', $mppNode);
        var $selectionsTags = $('.js-mpp-filter-set-selections', $mppContainer);
        var $shadeSlide = $('.js-product-brief-shades__grid', $mppContainer);
        var filterString = 'all';
        var filterClassSufix = 'product-grid__item--filter-';
        var savedDivTag = [];
        var hasFilters = false;
        var urlString = window.location.href;

        // Loop through all products
        $products.each(function () {
          var $thisProduct = $(this);
          var hasSkuFilters = false;
          // If not filterable, continue

          if (!$thisProduct.data('attributes').tags && !$(this).data('attributes').skuTags) {
            return;
          }

          var data = '';

          if ($thisProduct.data('attributes').tags) {
            data = $thisProduct.data('attributes').tags;
            // process product filters first
            properTags = processTags(data);
            // loop tags and add filter class to element
            hasFilters = loopTags($thisProduct, properTags, 'product-filter', $filterSets);
          }

          if ($thisProduct.data('attributes').skuTags) {
            data = $thisProduct.data('attributes').skuTags;
            // process sku filters first
            properTags = processTags(data);
            // loop tags and add filter class to element + filter type
            hasSkuFilters = loopTags($thisProduct, properTags, 'sku-filter', $filterSets);
            if (!hasFilters && hasSkuFilters) {
              hasFilters = true;
            }
            processShadesForFiltering($thisProduct.find('.js-product-brief-shades-item'));
          }
        });

        if (hasFilters) {
          // show the filter buttons if there are is least 1 filter available
          $filtersParent.removeClass('hidden');
        }

        // Loop through our filter sets and hide any without filters with tags
        $filterSets.each(function () {
          if ($(this).children('.hidden').length === $(this).children().length) {
            $(this).closest('.mpp-filter-set__section').hide();
          }
        });

        function processTags(tagsData) {
          if (typeof tagsData !== 'string') {
            return [];
          }
          var newData = tagsData
            .replace(/-/g, '')
            .replace(/ /g, '')
            .replace(/\s+/g, '')
            .replace(/\//g, '')
            .toLowerCase();
          // Loop through our tags, split them by comma, then trim the whitespace
          var tags = _.map(newData.split(','), $.trim);

          return tags;
        }

        function loopTags($elem, properTags, filterType, $filterSets) {
          hasFilters = false;
          var filterClass = '';

          // Loop through our tags, and add the class to this product item
          _.each(properTags, function (index) {
            filterClass = 'product-grid__item--filter-' + index;
            $elem.addClass(filterClass);
            hasFilters = true;
            if ($filterSets.length) {
              // show the filter when called from product
              $filterSets
                .find('[data-filter=".' + filterClass + '"]')
                .data('filterType', filterType)
                .attr('data-filter-type', filterType)
                .removeClass('hidden');
            }
          });

          return hasFilters;
        }

        function processShadesForFiltering($shades) {
          $.each($shades, function () {
            var $thisShade = $(this);

            if ($thisShade.data('attributes').tags) {
              var tags = processTags($thisShade.data('attributes').tags);

              loopTags($thisShade, tags, 'sku-filter', {});
            }
          });
        }

        // Deeplinking support
        function getUrlParameter(name) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
          var results = regex.exec(location.search);

          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        function toggleFilterButtons() {
          var filterActive = $filterBtn.filter('.active').length || false;
          var gridReset = $filterBtn.filter('.selected').length || false;

          if (filterActive) {
            $submitBtn
              .removeClass('button--disabled')
              .removeClass('disabled')
              .removeClass('js-reset-filters');
            $resetBtn.removeClass('disabled');
            $mixItUpEl.addClass('js-mpp-grid--filtered');
          }
          if (gridReset && !filterActive) {
            // if there are no active filters but the grid was filtered
            // by something ( so there are selected item ), the submit button has to be
            // flaged as reset
            $submitBtn.addClass('js-reset-filters');
          }
        }

        function changeFilterParam() {
          var filterParameter = [];
          var filterContent = '';
          var filterParameterSet = '';

          urlString = urlString.split('?')[0];
          $filterBtn.filter('.active').each(function () {
            filterContent = $(this)
              .attr('data-filter')
              .split('.product-grid__item--filter-')
              .join('');
            filterParameter.push(filterContent);
          });
          if (filterParameter.length > 0) {
            filterParameterSet = '?filter=' + filterParameter.join(',');
          }
          window.history.pushState({}, '', urlString + filterParameterSet);
        }

        function getFilterCount() {
          var activeFilters = [];

          $filterBtn.filter('.active').each(function () {
            activeFilters.push($(this).data('filter'));
          });
          var activeFilterSelector = activeFilters.join('') || itemSelector;

          return parseInt($products.filter(activeFilterSelector).length);
        }

        function simulateFilterCount(simulateSelector) {
          activeFilters = [];
          $filterBtn.filter('.active').each(function () {
            activeFilters.push($(this).data('filter'));
          });
          activeFilters.push(simulateSelector);
          var activeFilterSelector = activeFilters.join('') || itemSelector;

          return parseInt($products.filter(activeFilterSelector).length);
        }

        function updateResultCount() {
          // Display # of filtered results
          var count = getFilterCount();

          $itemCountContainer.text(count);
        }

        function updateAvailableFilters() {
          $filterBtn.filter(':not(.active)').each(function () {
            var simulateCount = simulateFilterCount($(this).data('filter'));

            toggleFilterElement(simulateCount, $(this));
          });
          var availableFilters = 0;
          var $filterTitle = $();

          $filterSets.each(function () {
            availableFilters = $(this).find($filterBtn).filter(':not(.disabled)').length;
            $filterTitle = $(this).prev('.js-mpp-filter-set__title');
            if ($filterTitle.length) {
              toggleFilterElement(availableFilters, $filterTitle);
            }
          });
        }

        function toggleFilterElement(count, $el) {
          if (count === 0) {
            $el.addClass('disabled');
          } else {
            $el.removeClass('disabled');
          }
        }

        // Grabs the filter selectors and joins them
        function filter() {
          var filters = [];
          var skuFilters = [];
          var activeFiltersCount = 0;

          $filterBtn.filter('.active').each(function () {
            filters.push($(this).data('filter'));
            if ($(this).data('filterType') === 'sku-filter') {
              skuFilters.push($(this).data('filter'));
            }
          });

          $(document).trigger('menu:anchored_update');

          // trigger event to filter skus
          $(document).trigger('grid.activeFilter', { skuFilters: skuFilters });

          // Compound selector strings to use 'and' logic
          activeFiltersCount = filters.length;
          if (!activeFiltersCount) {
            $activeFiltersCount.html('');
          } else {
            // Hide promo items when filters are active
            filters.push(itemSelector);

            // Update filters count
            $activeFiltersCount.html('(' + activeFiltersCount + ')');
          }
          filterString = filters.join('') || 'all';

          if ($mixItUpEl.hasClass('mixitup-initialized')) {
            $mixItUpEl.fadeTo(300, 0.4, function () {
              $(this).mixItUp('filter', filterString);
            });
            $filterBtn.removeClass('selected').filter('.active').addClass('selected');
            $thisTemplate.addClass('mpp-filter-set--filtered');
            $mppContainer.addClass('mpp-container--filtered');
            
            if (Drupal.settings.global_variables && Drupal.settings.global_variables.cr22) {
              $(window).scrollTop(0);
            }
          }
        }

        // Collect each filter
        $triggerSets.each(function () {
          var $triggers = $('.js-mpp-filter-set-button', this);

          $triggers.on('click', function (event) {
            if ($(this).hasClass('disabled')) {
              return;
            }
            event.preventDefault();
            $(this).toggleClass('active');
            updateResultCount();
            updateAvailableFilters();
            toggleFilterButtons();
            changeFilterParam();
          });
          $triggers.keyup(function (event) {
            if ($(this).hasClass('disabled')) {
              return;
            }
            if (event.keyCode === 13) {
              $(this).toggleClass('active');
              updateResultCount();
              updateAvailableFilters();
              toggleFilterButtons();
            }
          });
        });
        function clearFilters() {
          $filterBtn.removeClass('active');
          updateAvailableFilters();
          updateResultCount();
        }
        // Reset filters
        function reset() {
          var $mixItUpEl = $(gridSelector, context);

          $mixItUpEl.removeClass('js-mpp-grid--filtered');
          $mixItUpEl.fadeTo(300, 0.4, function () {
            $(this).mixItUp('filter', 'all');
          });
          $filterBtn.removeClass('active').removeClass('selected');
          toggleFilterButtons();
          $thisTemplate.removeClass('mpp-filter-set--filtered');
          $mppContainer.removeClass('mpp-container--filtered');
          $selectionsTags.fadeOut(100, function () {
            $(this).text('').removeClass('active');
          });
          $(document).trigger('grid.reset.filters');
          $activeFiltersCount.html('');
        }

        // Close menu
        function close() {
          toggleFiltersContainer();
          $filterBtn.filter('.selected').addClass('active');
          updateResultCount();
        }

        function toggleFiltersContainer() {
          var $filtersOverlay = $('.js-mpp-filter-set__container--overlay', $thisTemplate);
          var $filtersInner = $('.js-mpp-filter-set__container--inner', $thisTemplate);

          $thisTemplate.css({ overflow: '' });
          $controlsContainer.toggleClass('full-page-takeover');
          if (Drupal.settings.global_variables && Drupal.settings.global_variables.cr22) {
            $controlsContainer[0].scrollIntoView();
            $html.toggleClass('mpp-container__overlay');
            $thisTemplate.toggle();
          } else {
            $thisTemplate.animate({ width: 'toggle' }, 100);
          }
          $filtersInner.animate(
            {
              left: 0
            },
            500,
            function () {
              if ($thisTemplate.hasClass('ready-state')) {
                // if the template has the ready-state we need to reset the css
                // so it has the same look on reopening
                $thisTemplate.removeClass('ready-state');
                $filtersInner.css({ left: '' }).addClass('loading');
                $filtersOverlay.css({ opacity: '' }).addClass('loading');
              } else {
                $thisTemplate.addClass('ready-state');
              }
              $thisTemplate.trigger('filters.visible');
            }
          );
          $filtersOverlay.animate(
            {
              opacity: 0
            },
            400,
            function () {
              $filtersInner.removeClass('loading');
              $filtersOverlay.removeClass('loading');
            }
          );
        }

        // Apply results
        $submitBtn.once().click(function (event) {
          var $button = $(this);

          event.preventDefault();
          if ($button.hasClass('button--disabled')) {
            return;
          }
          if ($button.hasClass('js-reset-filters')) {
            reset();
          } else {
            filter();
          }
          close();
        });

        // Toggle menu
        $triggerBtn.once().click(function () {
          if ($(this).hasClass('mpp-filter-cta--close')) {
            close();
          } else {
            toggleFiltersContainer();
          }
        });

        if (Drupal.settings.global_variables && Drupal.settings.global_variables.cr22) {
          $filterTitleBtn.once().click(function () {
            close();
            changeFilterParam();
          });
        }

        $closeBtn.once().click(function () {
          close();
          changeFilterParam();
        });

        $collapsedFilter.once().click(function () {
          var $this = $(this);

          if ($this.hasClass('disabled')) {
            return;
          }
          $this.toggleClass('opened').next('.js-mpp-filter-set__filters').toggleClass('collapsed');
        });

        $triggerBtn.keyup(function (event) {
          if (event.keyCode === 13) {
            if ($(this).hasClass('mpp-filter-cta--close')) {
              close();
            } else {
              $thisTemplate.fadeIn(100);
              $('.mpp-filter-cta--close', $thisTemplate).focus();
            }
          }
        });

        $(document).keyup(function (event) {
          if (event.keyCode === 27 && $thisTemplate.is(':visible')) {
            close();
          }
        });

        if (Drupal.settings.global_variables && Drupal.settings.global_variables.cr22) {
          $(document).mousedown(function (event) {
            if (
              $template.is(':visible') && 
              ($(event.target).parent().hasClass('mpp-container__overlay') || $(event.target).closest('.site-header__container').length !== 0)
            ) {
              close();
            }
          });
        }

        $resetBtn.once().click(function (event) {
          event.preventDefault();
          if ($(this).hasClass('button--disabled')) {
            return;
          }
          clearFilters();
          changeFilterParam();
          if ($mixItUpEl.hasClass('.js-mpp-grid--filtered')) {
            $submitBtn.addClass('js-reset-filters');
          } else {
            toggleFilterButtons();
          }
        });

        $mixItUpEl.on('mixEnd', function () {
          toggleFilterButtons();
          $shadeSlide.each(function () {
            Drupal.behaviors.productBriefShadesV1.reinitShadeCarousel($(this));
          });
        });

        if (urlString.includes('?filter=')) {
          var $currentFilter = '';
          var filterValues = urlString.split('?filter=').pop().split(',');

          filterValues.forEach(function (val) {
            $currentFilter = $filterBtn.filter(
              '[data-filter=".product-grid__item--filter-' + val + '"]'
            );
            if ($currentFilter.length > 0) {
              $currentFilter.addClass('active');
              updateResultCount();
              updateAvailableFilters();
              toggleFilterButtons();
            }
          });
          $mixItUpEl.addClass('mixitup-initialized');
          filter();
        }
      });
    },
    attached: false
  };
})(jQuery);
